

export default function About() {

    return (

        <div className="about-block" id="about">

            <div className="about-col1">

                <div className="about-title">A few words about us</div>
                <div className="about-text">
                    We are a team of developers, data analysists and content management professionals with 20+ years of
                    expertise in the field of ecommerce development, web-scraping, data transformation, data analysis,
                    taxonomy creation and mappings, content management, standardization and data flow.
                    <br/><br/>
                    Nowadays ecommerce data is not only about quality, but also about a speed of delivery. That's why we
                    deliver qualitative, accurate and in-time results for our partners. Getting to the core of client’s
                    issue helps us resolving it in the most efficient, complete and timewise way.
                </div>

                <div className="about-title">Why choose us?</div>
                <div className="about-text">Because we are trusted by many brands. Because we deliver
                    top-notch results and get the job done. Because we value long-term business relations.
                    Last, but not least, because our services are highly valued yet very affordable.
                </div>

            </div>

            <div>
                <img src="/images/aboutus_banner_1_r1.jpg" alt="Team of Acepim" className="about-picture"/>
            </div>


        </div>

    )
}
